import React from 'react';
import './StayInTouch.css';

const StayInTouch = () => {
    return (
        <section className="stayintouch">
            <div className="container text-center">
                <h2 className="heading__title">
                    Stay in touch with us
                </h2>
                <p className="sub__title">Tell us about your requirements</p>
                <a className="c-btn" href="/">Connect with us</a>
            </div>
        </section>
    )
}

export default StayInTouch
